
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support-for-disaster-prevention",
      function () {
        return require("private-next-pages/support-for-disaster-prevention/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support-for-disaster-prevention"])
      });
    }
  